import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

@inject('customerMasterDataStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {customerMasterDataStore, dataType} = this.props
    if (dataType === 'parameter') {
      customerMasterDataStore.onGetMasterDataAction({...record, type: 'parameter'}).then(res => {
        this.setState({
          addModalVisible: true,
        })
      })
    } else {
      customerMasterDataStore.onGetMasterDataAction(record).then(res => {
        this.setState({
          addModalVisible: true,
        })
      })
    }
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {customerMasterDataStore, dataType} = this.props
    confirm({
      title: 'Delete Data',
      icon: <QuestionCircleFilled/>,
      content: 'Are you sure you want to delete it ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk() {

        if (dataType === 'parameter') {
          customerMasterDataStore.onDeleteMasterDataAction({...record, type: 'parameter'})
        } else {
          customerMasterDataStore.onDeleteMasterDataAction({...record})
        }
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {customerMasterDataStore} = this.props
    customerMasterDataStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {customerMasterDataStore, dataType, record, t} = this.props
    const {pageNo, pageSize, itemCount, masterDataList} = customerMasterDataStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(masterDataList)} pagination={pagination} rowClassName={this.getRowClassName} rowKey="id">
          {dataType !== 'parameter' ? <>
            <Table.Column title={t(`customerMaster.customer`)} dataIndex="customerStr" key="Customer" ellipsis={true}/>
            <Table.Column title={t(`customerMaster.name`)} dataIndex="name" key="Name" ellipsis={true}/>
          </> : null}
          <Table.Column title={t(`customerMaster.property`)} dataIndex="property" key="Property" ellipsis={true}/>
          <Table.Column title={t(`customerMaster.value`)} dataIndex="value" key="Value" ellipsis={true}/>
          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button onClick={() => this.handleEdit(record)} type="link" icon={<EditOutlined/>} title="Edit"/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title="Delete"/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          record={record}
          dataType={dataType}
          title="edit"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
